// extracted by mini-css-extract-plugin
module.exports = {"headerItem":"TrialCardHeaderItem__headerItem","headerItemTitle":"TrialCardHeaderItem__headerItemTitle"};